import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import spartaStoreUtility from "global/sparta-store-utility";
import spartaEventsUtility from "global/sparta-events-utility";
import spartaMediaQueryUtility from "global/sparta-mediaquery-utility";
import spartaUILayersUtility from "global/sparta-ui-layers-utility";
import spartaStyleUtility from "global/sparta-style-utility";
import Module from "global/sparta-module-utility";
import handlebarsRuntime from "vendor/handlebars-runtime";
import hb from "vendor/handlebars-runtime";
import * as navSearch from "modules/global/global-nav-module/5.4.0/js/nav-search-bootstrap";
import spartaTemplates from "modules/global/global-nav-module/5.4.0/js/templates";
import "css!modules/global/global-nav-module/5.4.0/css/global-nav-module.scss.css";







var defaults = {
    target: ".global-nav-module",
    $target: $(),
    debug: false
  },

  required = {
    data: {
      "module": ""
    }
  },


  settings = {}

export default class globalNavModule extends Module {

  constructor(options) {
    super(options);
  }

  init(args = {}) {
    settings = $.extend({}, defaults, args, required);
    settings.$target = $(settings.target);




    Object.keys(settings.data).forEach((data) => {
      if (settings.$target.data(data)) {
        settings.data[data] = settings.$target.data(data);
      }
    });

    this._enableSearch();

    this._debug("global-nav-module init");
    this._debug(settings);

    var $globalNavModule = $('#globalNavModule'),
      $fakeHeaderBG = $('#fakeHeaderBG'),
      $ancShowHideRelatedLinks = $('#ancShowHideRelatedLinks'),
      $relatedLinksArrowIcon = $('#relatedLinksArrowIcon'),
      $nav = settings.$target.find('nav'),
      navHeight = $nav.height(),
      $spaPageHeaderContainer = $('#spaPageHeaderContainer'),
      $navTabArrow = $('#navTabArrow'),

      $navGlobalLinks = $('.nav-link-global'),
      $navLinks = $('.nav-links'),
      $navSectionTitle = $('.spa-nav-section-title'),
      $navSectionList = $('.spa-nav-section-list'),
      $spaNavSectionTitleArrow = $('.spa-nav-section-title-arrow');

    $nav.css('margin-top', '-' + navHeight + 'px');

    $navSectionTitle.tabindex = 12;

    $navSectionTitle.keyup(function(e) {
      if (e.keyCode === 13) {
        _navSectionToggle();
      }
    });

    var _navToggle = function(e) {
      $(this).blur();

      if ($nav.hasClass('show')) {
        $nav.animate({
          'margin-top': '-' + navHeight + 'px'
        }, 300, function() {
          $nav.removeClass('show');
          $fakeHeaderBG.removeClass('border-show'); 
          $spaPageHeaderContainer.removeClass('border-show');
          $ancShowHideRelatedLinks.focus();
        });

        $relatedLinksArrowIcon.removeClass('arrow-rotate-up');
        $relatedLinksArrowIcon.addClass('arrow-rotate-down');
        setTimeout(function() {
          $navTabArrow.hide();
        }, 100);

      } else {


        if (spartaStoreUtility.getData('currentMQ.viewport') === "small") {
          $navSectionList.css('display', 'none');
        }
        $globalNavModule.addClass('show-nav');
        $fakeHeaderBG.addClass('border-show');
        $spaPageHeaderContainer.addClass('border-show');
        $nav.addClass('show')
          .animate({
            'margin-top': '0px'
          }, 300, function() {
            $ancShowHideRelatedLinks.focus();
          });
        $relatedLinksArrowIcon.removeClass('arrow-rotate-down');
        $relatedLinksArrowIcon.addClass('arrow-rotate-up');
        setTimeout(function() {
          $navTabArrow.show();
        }, 100);

        _equalizerReflowStack($navLinks);

        setTimeout(function() {
          _equalizerReflowStackGlobal($navGlobalLinks);
        }, 100);

      }
      e.preventDefault();
    };

    $(this.eventDelegatorString).on('click', '#ancShowHideRelatedLinks', _navToggle);


    var _navSectionToggle = function(e) {
      var $this = $(this),
        $siblingList = $this.next('ul'),
        $thisTitleArrow = $this.find($spaNavSectionTitleArrow);

      if (spartaStoreUtility.getData('currentMQ.viewport') === "small") {
        $siblingList.slideToggle(200);
        if (!$thisTitleArrow.hasClass('arrow-rotate-down') && !$thisTitleArrow.hasClass('arrow-rotate-right')) {
          $thisTitleArrow.addClass('arrow-rotate-down');
        } else if ($thisTitleArrow.hasClass('arrow-rotate-down')) {
          $thisTitleArrow.removeClass('arrow-rotate-down')
            .addClass('arrow-rotate-right');
        } else if ($thisTitleArrow.hasClass('arrow-rotate-right')) {
          $thisTitleArrow.removeClass('arrow-rotate-right')
            .addClass('arrow-rotate-down');
        }
      }

      e.preventDefault();
    };

    $navSectionTitle.click(_navSectionToggle);
    $(window).on('resize orientationchange', function(e) {
      navHeight = $nav.height();

      if (!$nav.hasClass('show')) {
        $nav.css('margin-top', '-' + navHeight + 'px');
      }

      if (spartaStoreUtility.getData('currentMQ.viewport') === "small" && $navSectionList.css('display') === 'inline-block') {
        $spaNavSectionTitleArrow.removeClass('arrow-rotate-down')
          .addClass('arrow-rotate-right');
      }

      _equalizerReflowStack($navLinks);
      _equalizerReflowStackGlobal($navGlobalLinks);
    });

    var _equalizerReflowStack = function(list) {
      if (spartaStoreUtility.getData('currentMQ.viewport') !== "small") {
        list.height('');
        $navSectionList.css('display', 'none');
      } else {
        list.height('auto');
      }
    };

    var _equalizerReflowStackGlobal = function(list) {
      if (spartaStoreUtility.getData('currentMQ.viewport') !== "small") {
        list.height('');
      } else {
        list.height('auto');
      }
    };
  }

  _enableSearch() {

    if (this.settings.hasSearch !== "false" && typeof navSearch !== "undefined") {
      this.settings.$target.addClass("has-search");
      navSearch.default.init();
    } else if (this.settings.hasSearch === "false") {
      $('.default-nav-links').removeClass('acco-for-params');
    }
  }

  _debug(msg) {
    if (window.console && settings.debug) {
      console.log(msg);
    }
  };
}
